export default __webpack_public_path__ + "static/screenshot_arctic-01f8f636c83b0ce9a7a9c7b430116355.png";